export const defineUniquePromoCodes = ({
    productList,
    uniquePromoCodes,
    setUniquePromoCodes
}) => {
    const allPromoCodesMap = new Map([]);

    uniquePromoCodes?.forEach(item =>
        allPromoCodesMap.set(item.promoCode, item)
    );

    productList?.forEach(item => {
        if (item?.resolvedPromoCode) {
            allPromoCodesMap.set(item.resolvedPromoCode, {
                promoCode: item.resolvedPromoCode,
                promoMessage: item?.messageWithPromoCode
            });
        }
    });

    const newPromoCodes = Array.from(allPromoCodesMap.values())
    const hasChanges = newPromoCodes?.length > uniquePromoCodes?.length;

    if (hasChanges) {
        setUniquePromoCodes(newPromoCodes)
    }
}
